import { render, staticRenderFns } from "./Substation.vue?vue&type=template&id=72812b67&scoped=true"
import script from "./Substation.vue?vue&type=script&lang=js"
export * from "./Substation.vue?vue&type=script&lang=js"
import style0 from "./Substation.vue?vue&type=style&index=0&id=72812b67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72812b67",
  null
  
)

export default component.exports